import { Download, Eye, Layers, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { productCodeToExplorerLayerIdMappings } from "pages/geoscape-data/constants";
import { useHistory } from "react-router";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";
import { viewDatasetInExplorer } from "../catalogue-page";

interface CatalogueActionsCardProps {
  licenced: boolean;
  /** Backend product code, e.g. "GEOSCAPE ROADS". */
  datasetProductCode: string;
  displayName: string;
}

export const CatalogueActionsCard = ({
  licenced,
  datasetProductCode,
  displayName,
}: CatalogueActionsCardProps) => {
  const { showNewMessage } = useIntercom();
  const history = useHistory();

  const hasExplorerLayer = !!productCodeToExplorerLayerIdMappings.get(
    datasetProductCode,
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Get this data</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {licenced ? (
          <Button asChild className="w-full">
            <a
              href={`${Routes.dataDownload}?product=${encodeURIComponent(
                datasetProductCode,
              )}&licenced=${licenced}`}
            >
              <Download />
              Download Dataset
            </a>
          </Button>
        ) : (
          <Button
            className="w-full"
            onClick={() => {
              showNewMessage(
                `I'd like to talk to someone about "${displayName}"`,
              );
            }}
          >
            <MessageSquare />
            Chat with Our Team
          </Button>
        )}
        <Button
          variant="outline"
          className="w-full"
          disabled={!hasExplorerLayer}
          onClick={() => viewDatasetInExplorer(datasetProductCode, history)}
        >
          <Layers />
          Visualise Data
        </Button>
        <Button variant="outline" className="w-full" disabled>
          <Eye />
          View Sample
        </Button>
      </CardContent>
    </Card>
  );
};
